import React from 'react';
import { s } from '../styles';
import { BulletCard } from '../atoms';
import { IconPelvis, IconPerson, IconSpark } from '../icons';

// Screen 1 — Anatomy. Four bullets + a labelled illustration. The
// illustration must live at public/Gemini_Generated_Image_nl687hnl687hnl68.{png,webp}
// so Vite serves it at the matching path. WebP source is ~97% smaller
// than the original PNG (1.0 MB → 25 KB); PNG kept as fallback for
// very old Safari.
export function Content({ t }) {
  return (
    <div className="screen-enter">
      <h1 style={s.title} className="screen-enter-child">{t('fl_anatomy_title')}</h1>
      <div style={s.bulletStack} className="screen-enter-child">
        <BulletCard icon={<IconPelvis />} className="stagger-item" style={{ '--stagger-i': 0 }}>
          {t('fl_anatomy_bullet_1')}
        </BulletCard>
        <BulletCard icon={<IconPerson />} className="stagger-item" style={{ '--stagger-i': 1 }}>
          {t('fl_anatomy_bullet_2')}
        </BulletCard>
        <BulletCard icon={<IconSpark />} className="stagger-item" style={{ '--stagger-i': 2 }}>
          {t('fl_anatomy_bullet_3')}
        </BulletCard>
        <BulletCard icon={<IconPelvis />} className="stagger-item" style={{ '--stagger-i': 3 }}>
          {t('fl_anatomy_bullet_4')}
        </BulletCard>
      </div>
      <picture>
        <source srcSet="/Gemini_Generated_Image_nl687hnl687hnl68.webp" type="image/webp" />
        <img
          src="/Gemini_Generated_Image_nl687hnl687hnl68.png"
          alt=""
          className="screen-enter-child"
          width={1298}
          height={816}
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
            aspectRatio: '1298 / 816',
            maxWidth: 360,
            margin: '16px auto 0',
            borderRadius: 'var(--radius-md, 12px)',
          }}
        />
      </picture>
    </div>
  );
}

export function Footer({ t, onNext }) {
  return (
    <button type="button" style={{ ...s.cta, ...s.ctaEnabled }} onClick={onNext}>
      {t('fl_anatomy_cta')}
    </button>
  );
}
